<template>
    <div class="layout">
        <LayoutHeader v-if="showHeader" @ready="headerReady = true"  />
        <div class="layout-content" :class="{ withFooter: showFooter }">
            <router-view v-if="headerReady" />
        </div>
        <div v-if="showFooter" class="layout-footer-fade"></div>
        <LayoutFooter v-if="showFooter" />


        <Popup v-model="$store.state.show" position="bottom" round get-container="#app" @closed="handleClose">
            <div class="layout-loading" v-if="$store.state.loading">
                <div class="title">
                    {{ $t('node.progress') }}
                    <span class="layout-popup-close" @click="handleClose">×</span>
                </div>
                <div class="loading">
                    <div class="loader-inner ball-spin-fade-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="desc">{{ $t('node.progress') }}</div>
            </div>
            <div class="layout-claim" v-else>
                <div class="title">
                    {{ $t('node.progress') }}
                    <span class="layout-popup-close" @click="handleClose">×</span>
                </div>
                <div class="claim-ok">
                    <div class="title">
                        {{ $t('node.executionSuccessful') }}
                    </div>
                    <div class="desc">
                        <span>{{ $t('node.at') }}BscScan {{ $t('node.view') }}:0xe7d92</span>
                    </div>
                </div>

            </div>
        </Popup>
    </div>

</template>

<script>
import LayoutHeader from './header.vue'
import LayoutFooter from './footer.vue'
import { Overlay, Popup, Loading } from 'vant';
export default {
    name: 'layout',
    components: {
        LayoutHeader,
        Popup,
        LayoutFooter,
        Loading
    },
    computed: {
        showHeader() {
            return this.$route.meta.header !== false
        },
        showFooter() {
            return !!this.$route.meta.tab
        }
    },
    data(){
        return{
            headerReady:false
        }
    },
    methods: {
        handleClick() {
        },
        handleClose() {
            // 设置true 会显示弹窗
            // this.$store.commit('handleShow',true)
            this.$store.commit('handleShow', false)
        }
    }
}
</script>

<style lang="less">
.layout {
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 375px;
    margin: 0 auto;
    background: #F3F2ED;
    overflow: hidden;

    .layout-content {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        overflow-y: auto;

        &.withFooter {
            padding-bottom: 94px;
        }
    }
}

.layout-footer-fade {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 25;
    height: 108px;
    pointer-events: none;
    background-image: linear-gradient(179deg, rgba(243, 242, 237, 0) 0%, #F3F2ED 20%);
}

.loading-warp {
    position: absolute;


}

.layout-loading {
    padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.loading {
        padding-top: 64px;
        display: flex;
        height: 100px;
        justify-content: center;

        @keyframes ball-spin-fade-loader {
            50% {
                opacity: 0.3;
                -webkit-transform: scale(0.4);
                transform: scale(0.4);
            }

            100% {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
            }
        }

        .ball-spin-fade-loader {
            position: relative;
            margin-left: -15px;
        }

        .ball-spin-fade-loader>div:nth-child(1) {
            top: 25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0s infinite linear;
            animation: ball-spin-fade-loader 1s 0s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(2) {
            top: 17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.12s infinite linear;
            animation: ball-spin-fade-loader 1s 0.12s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(3) {
            top: 0;
            left: 25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.24s infinite linear;
            animation: ball-spin-fade-loader 1s 0.24s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(4) {
            top: -17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.36s infinite linear;
            animation: ball-spin-fade-loader 1s 0.36s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(5) {
            top: -25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0.48s infinite linear;
            animation: ball-spin-fade-loader 1s 0.48s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(6) {
            top: -17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.6s infinite linear;
            animation: ball-spin-fade-loader 1s 0.6s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(7) {
            top: 0;
            left: -25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.72s infinite linear;
            animation: ball-spin-fade-loader 1s 0.72s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(8) {
            top: 17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.84s infinite linear;
            animation: ball-spin-fade-loader 1s 0.84s infinite linear;
        }

        .ball-spin-fade-loader>div {
            background-color: #D1A74C;
            width: 15px;
            height: 15px;
            border-radius: 100%;
            margin: 2px;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
            position: absolute;
        }
    }

    >.desc {
        margin-top: 16px;
        text-align: center;
        letter-spacing: -0.25px;
        font-size: 14px;
        opacity: 0.6;
    }
}

.layout-claim {
    padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    .claim-ok {
        padding-top: 68px;

        >img {
            width: 137.41px;
            height: 100px;
            margin: 0 auto;
        }

        >.title {
            font-size: 18px;
            margin-top: 16px;
            text-align: center;
            letter-spacing: -0.25px;
        }

        >.desc {
            font-size: 14px;
            margin-top: 8px;
            letter-spacing: -0.25px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                opacity: 0.6;

            }

            img {
                width: 16px;
                height: 16px;
                margin-left: 7px;
            }
        }
    }

}
</style>